module.exports = __webpack_public_path__ + "static/media/atmosphere.512bf240.gif";